export function normalizePromptTitle(title?: string): string | undefined {
  if (!title) {
    return undefined
  }

  const trimmed = title.trim()
  if (!trimmed) {
    return undefined
  }

  const withoutCustomPrefix = trimmed.replace(/^custom\s+\d+\s*:\s*/i, '').trim()
  return withoutCustomPrefix || undefined
}
